/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserClaimModel } from './UserClaimModel';
import {
    UserClaimModelFromJSON,
    UserClaimModelFromJSONTyped,
    UserClaimModelToJSON,
    UserClaimModelToJSONTyped,
} from './UserClaimModel';

/**
 * 
 * @export
 * @interface UpdateUserModel
 */
export interface UpdateUserModel {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserModel
     */
    username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserModel
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserModel
     */
    emailConfirmed?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserModel
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserModel
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserModel
     */
    middleName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserModel
     */
    phoneNumber?: string | null;
    /**
     * Добавочный телефон
     * @type {string}
     * @memberof UpdateUserModel
     */
    workPhone?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUserModel
     */
    userRoles?: Array<string> | null;
    /**
     * 
     * @type {Array<UserClaimModel>}
     * @memberof UpdateUserModel
     */
    userClaims?: Array<UserClaimModel> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserModel
     */
    resetPassword?: boolean | null;
}

/**
 * Check if a given object implements the UpdateUserModel interface.
 */
export function instanceOfUpdateUserModel(value: object): value is UpdateUserModel {
    return true;
}

export function UpdateUserModelFromJSON(json: any): UpdateUserModel {
    return UpdateUserModelFromJSONTyped(json, false);
}

export function UpdateUserModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserModel {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'] == null ? undefined : json['username'],
        'email': json['email'] == null ? undefined : json['email'],
        'emailConfirmed': json['emailConfirmed'] == null ? undefined : json['emailConfirmed'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'workPhone': json['workPhone'] == null ? undefined : json['workPhone'],
        'userRoles': json['userRoles'] == null ? undefined : json['userRoles'],
        'userClaims': json['userClaims'] == null ? undefined : ((json['userClaims'] as Array<any>).map(UserClaimModelFromJSON)),
        'resetPassword': json['resetPassword'] == null ? undefined : json['resetPassword'],
    };
}

export function UpdateUserModelToJSON(json: any): UpdateUserModel {
    return UpdateUserModelToJSONTyped(json, false);
}

export function UpdateUserModelToJSONTyped(value?: UpdateUserModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
        'email': value['email'],
        'emailConfirmed': value['emailConfirmed'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'middleName': value['middleName'],
        'phoneNumber': value['phoneNumber'],
        'workPhone': value['workPhone'],
        'userRoles': value['userRoles'],
        'userClaims': value['userClaims'] == null ? undefined : ((value['userClaims'] as Array<any>).map(UserClaimModelToJSON)),
        'resetPassword': value['resetPassword'],
    };
}

